module.exports = __webpack_public_path__ + "img/hp_font.4ac1573f.png";